import { INDIA_OFFICE } from "@/data/homeContent";

export { INDIA_OFFICE };

/** Search text for the office. Google Maps finds the building from the name and sector. */
const MAP_QUERY = "BPTP Park Centra, Sector 30, Gurgaon, Haryana 122001, India";

/** Embeddable map (no API key needed). */
export function indiaMapEmbedUrl() {
  return `https://www.google.com/maps?q=${encodeURIComponent(MAP_QUERY)}&z=15&output=embed`;
}

/** Opens Google Maps (or the Maps app on phones) for directions. */
export function indiaMapLinkUrl() {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAP_QUERY)}`;
}

export function indiaWhatsAppUrl() {
  const digits = String(INDIA_OFFICE.tel || INDIA_OFFICE.phone || "").replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}` : null;
}
